module.exports = __webpack_public_path__ + "static/CSharp-e8460f0d8b9df01e9460bfd1ade0e8c8.png";